import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { UtilsService } from '../services/utils.service';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, Subscription } from 'rxjs';
@Component({
  selector: 'app-footers',
  imports: [RouterModule],
  templateUrl: './footers.component.html',
  styleUrls: ['./footers.component.scss']
})
export class FootersComponent implements OnInit, OnDestroy {
  isQuickLinksOpen = false;
  isContactInfoOpen = false;
  isHome = false;
  private routerSubscription?: Subscription;

  constructor(
    private renderer: Renderer2,
    private router: Router,
    public utils: UtilsService
  ) { }

  ngOnInit(): void {
    this.updateHomeState(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.updateHomeState(event.urlAfterRedirects));

    if (this.utils.isBrowser) {
      setTimeout(() => {
        this.addTawkToScript();
      }, 9000);
    }
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  private updateHomeState(url: string): void {
    this.isHome = url.split('?')[0].split('#')[0] === '/';
  }

  toggleQuickLinks() {
    this.isQuickLinksOpen = !this.isQuickLinksOpen;
  }

  toggleContactInfo() {
    this.isContactInfoOpen = !this.isContactInfoOpen;
  }

  addTawkToScript(): void {
    if (this.utils.isBrowser) {
      const s1 = this.renderer.createElement('script');
      s1.type = 'text/javascript';
      s1.async = true;
      s1.src = 'https://embed.tawk.to/6767d5d1af5bfec1dbdfdcae/1ifmpmfio';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      this.renderer.appendChild(document.body, s1);
    }
  }

}
